import { Typography } from '@mui/material';

import { separateEveryThousandByComma } from '@occc-app/lib/numbers';

type RetailerNetworkMonthlyGoalProgressDescriptionProps = {
  title: string;
  progress: number;
  goal: number;
};

export const RetailerNetworkMonthlyGoalProgressDescription = ({
  title,
  progress,
  goal,
}: RetailerNetworkMonthlyGoalProgressDescriptionProps) => (
  <div>
    <Typography color='textSecondary' variant='body2'>
      {title}
    </Typography>
    <div>
      <Typography variant='h5' component='span'>
        {separateEveryThousandByComma(progress)}
      </Typography>
      <Typography color='textSecondary' variant='body2' component='span'>
        /{separateEveryThousandByComma(goal)}
      </Typography>
    </div>
  </div>
);
